import { Box, Collapse, Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolTextButton, PoolTypography } from '@synergy/components-next';
import { ReactElement, useMemo, useState } from 'react';

import { ArticleDetailVariantsAttribute } from './article-detail-variants-attribute';
import { ArticleDetailVariantsDropdown } from './article-detail-variants-drop-down';
import { useArticleDetailContext } from '../article-detail';

export const ArticleDetailVariants = (): ReactElement | null => {
    const { variants, attributeOptions } = useArticleDetailContext();
    const [showMore, setShowMore] = useState(false);

    const visibleAttributesCount = 4;
    const visibleAttributes = useMemo(() => attributeOptions.slice(0, visibleAttributesCount), [attributeOptions]);
    const hiddenAttributes = useMemo(() => attributeOptions.slice(visibleAttributesCount), [attributeOptions]);

    if (variants.length <= 1 && attributeOptions.length === 0) {
        return null;
    }

    return (
        <Grid container={true}>
            <Grid item={true} container={true} spacing={2} xs={12}>
                <Grid item={true} xs={12}>
                    <PoolTypography variant="statusLabel" component={Box} sx={{ pb: 2 }}>
                        <FormattedMessage id="app.article.detail.variants" />
                    </PoolTypography>
                </Grid>
                <Grid item={true} xs={12}>
                    <ArticleDetailVariantsDropdown />
                </Grid>
                {visibleAttributes.map(attribute => (
                    <Grid key={attribute.attributeId} item={true} xs={12} sm={6}>
                        <ArticleDetailVariantsAttribute attribute={attribute} />
                    </Grid>
                ))}
            </Grid>

            {hiddenAttributes.length > 0 && (
                <>
                    <Collapse in={showMore} timeout={200} sx={{ width: '100%' }}>
                        <Grid item={true} container={true} spacing={2} xs={12}>
                            {hiddenAttributes.map(attribute => (
                                <Grid key={attribute.attributeId} item={true} xs={12} sm={6}>
                                    <ArticleDetailVariantsAttribute attribute={attribute} />
                                </Grid>
                            ))}
                        </Grid>
                    </Collapse>

                    <Grid container={true} item={true} xs={12} sx={{ mt: showMore ? 2 : 0 }}>
                        <PoolTextButton color="primary" onClick={() => setShowMore(!showMore)}>
                            {showMore ? (
                                <FormattedMessage id="app.article.detail.variants.less" />
                            ) : (
                                <FormattedMessage id="app.article.detail.variants.more" />
                            )}
                        </PoolTextButton>
                    </Grid>
                </>
            )}
        </Grid>
    );
};
